<template>
  <Page slug="/how-to-use" title="How to Use" h1="How to Use">
    <p>
      This page provides a lot of information about how to get the most out of
      using this website. If you run into difficulty, please
      <a href="mailto:contact@choosenativeplants.com">reach out</a> to us.
    </p>
    <menu>
      <li><a href="#the-purpose">The purpose</a></li>
      <li><a href="#the-context">The context</a></li>
      <li><a href="#the-directions">The directions</a></li>
      <li><a href="#the-terms">The terms</a></li>
    </menu>
    <div class="tone light">
      <div class="carrier-wave">
        <img src="/assets/images/wave-top-light.png" class="wave" />
      </div>
      <article>
        <div class="facing">
          <h3 id="the-purpose">The purpose</h3>
          <div>
            <p>
              The purpose of this site is to provide a tool for those interested in
              finding PA native plants that fit the needs at home. The site allows
              those with a lot or a little knowledge of gardening to find native
              plants and what nurseries might be carrying them or if they are
              available from online sources.
            </p>
          </div>
        </div>
      </article>
      <article>
        <div class="facing">
          <h3 id="the-context">The context</h3>
          <ul>
            <li>
              <p>
                This project is a
                <a href="http://codeforphilly.org">Code for Philly Project.</a> This
                web site is open source under a GPL license.
              </p>
            </li>
            <li>
              <p>
                The database for this lookup tool is based upon Mark Skinner’s USDA
                database:
              </p>
              <p>
                United States Department of Agriculture and US Federal Highway
                Administration. 2017.
                <a href="http://www.nativerevegetation.org/era/">
                  National database
                </a>
                for pollinator-friendly revegetation and restoration. Compiled by
                Mark W. Skinner, Gretchen LeBuhn, David Inouye, Terry Griswold, and
                Jennifer Hopwood. Online at . Contact
                <a href="http://mwskinner55@gmail.com)">Mark W. Skinner</a>
                for updates or more information.
              </p>
            </li>
          </ul>
        </div>
      </article>
      <article>
        <h3 id="the-directions">The directions</h3>
        <p>
          Once you land on
          <a href="http://choosenativeplants.com">choosenativeplants.com</a>,
          decide if you just want to answer 5 questions to find some plants or if
          you want to use some filters.
        </p>
        <h4>Using filters</h4>
        <ul>
          <li>
            Tap the orange filter button and see the drawer of filters slide out
            from the left
          </li>
          <li>
            Go through the choices, opening and closing the accordions by tapping
            the down chevron to see all the choices for life cycle, plant type,
            sun exposure, water needs, pollinator attractors, color, availability
            whether online, local or both, height and bloom month
          </li>
          <li>
            "What's a Super Plant?" The first filter choice offered is "Super Plant."
            Super Plants are popular and highly recommended in some local gardening circles.
          </li>
          <li>
            After selecting all that apply to your needs, tap the apply button to
            the top left of the filter drawer
          </li>
          <li>
            The drawer will then close, and the columns of plant images you now
            see on the main page will be those that you filtered for.
          </li>
          <li>
            You can sort this list by tapping on the Sort By drop down. Choices
            for sort by include Common Name and Scientific Name.
          </li>
          <li>
            The small “i” ‘s that are superscripts on some terms are info
            tooltips. Hover if on a desktop or long press on a mobile device and
            the tooltip will explain the term.
          </li>
        </ul>
        <h4>Using 5 questions to find plants</h4>
        <ul>
          <li>
            Tap on the link that says “Not sure where to start? Answer 5 questions
            “
          </li>
          <li>A page with question number 1 will open.</li>
          <li>
            Answer each question in turn. at the last page of questions, you will
            see a “Show plants button.” Tap this button to return to the main
            page, which now has a list of plants and images that represent the
            answers to your questions.
          </li>
          <li>
            After selecting all that apply to your needs, tap the apply button to
            the top left of the filter drawer
          </li>
          <li>
            You can sort this list by tapping on the Sort By drop down. Choices
            for sort by include, height, name (latin and common), and color
          </li>
          <!--
          <li>
            The small “i” ‘s that are superscripts on some terms are info
            tooltips. Hover if on a desktop or long press on a mobile device and
            the tooltip will explain the term.
          </li>
          -->
        </ul>
        <h4>Favoriting Plants</h4>
        <ul>
          <li>Tap the heart on any image to add it to your favorite list</li>
          <li>
            This list allows you to essentially save what you are liking or want
            to check out later
          </li>
          <li>
            Unfavorite the plant by tapping the heart, it will no longer be a
            filled in heart, but an outlined heart. outlined heart = not a
            favorite; filled-in heart = favorite.
          </li>
        </ul>
        <h4>See your favorites</h4>
        <ul>
          <li>Tap the favorite list button</li>
          <li>
            This takes you to a page similar to the main page that shows only your
            favorites that you have selected.
          </li>
          <li>
            There is a “sort by” button, which you can tap to sort this list
            according to height, color, latin or common name.
          </li>
          <li>
            You can unfavorite a plant by tapping the heart and it will turn the
            heart back into an outlined heart which means “not favorite”
          </li>
        </ul>
        <h4>Get more info</h4>
        <ul>
          <li>
            Any of the image blocks has a “more info” link on it. Tap this link to
            open a popup that shows a larger picture of the plant, might give a
            description, and lists more characteristics of the plant.
          </li>
        </ul>
        <h4>Find the plants</h4>
        <ul>
          <li>
            Open the hamburger menu and tap on PA Nurseries. This will lead you to
            a page that lists PA nurseries that are known to carry many species.
          </li>
          <li>
            The nursery’s address, phone number and email are listed. Please
            contact the Nursery to determine if your favorite plants are in stock
            yet.
          </li>
          <li>
            The online website for each nursery is also listed. Some of the
            nurseries will allow online ordering.
          </li>
          <li>
            Once you have your favorite list, you can google for additional online
            sellers.
          </li>
        </ul>
        <h4>Contact us</h4>
        <ul>
          <li>
            To contact us, <a href="mailto:contact@choosenativeplants.com">reach out via email to contact@choosenativeplants.com</a>.
          </li>
        </ul>
      </article>
      <div class="carrier-wave">
        <img src="/assets/images/wave-bottom-light.png" class="wave" />
      </div>
    </div>
    <article>
      <h3 id="the-terms">The terms</h3>
      <p>
        By navigating this website, you are agreeing to the terms and conditions
        outlined below.
      </p>
      <p>
        The source code of this website and the data that
        enables it are maintained by volunteers with periodic assistance from
        botanists. This website is offered "as is." The creators of this website
        offer no warranty of the completeness and accuracy of the data within
        this website. The data provided on this website should not be cited in
        any scholarly articles or publications. The creators of this website
        should not be held accountable for errors or omissions.
      </p>
      <p>
        Any suggestion of the edibility or medicinal qualities of plants should
        not be directly followed. Rely on medical professionals for advice
        before ingesting or topically applying any plants.
      </p>
      <p>
        The use of bot scraping apps is not permitted. If you would like our
        dataset, just contact us and we'll give the data to you. Similarly, if
        you would like our source code of the website, see
        <a href="https://github.com/CodeForPhilly/pa-wildflower-selector"
          >our github project</a
        >
        as we are an open source project under a GPL license.
      </p>
      <p>
        This code is under a GPL license, which means if you use the code for
        your project, any enhancements need to be made publicly available as
        open source code as well.
      </p>
      <p>
        We are not responsible for any offensive wording that may appear on this
        website. We have controls in place to help prevent this, but we offer no
        warranty on the exclusion of offensive language.
      </p>
      <p>
        If you choose to use the features of the site that allow you to identify
        your favorite plants, these will be tracked only in your browser's local
        storage. A cookie is also used to enable Google Analytics so that we can
        analyze how much traffic the site is receiving. No other session tracking
        or cookies are used. By using these features you consent to the collection
        of this information.
      </p>
      <p>© 2021, 2022 Choose Native Plants - PA</p>
    </article>
    <Up />
    <div class="tone">
      <div class="carrier-wave">
        <img src="/assets/images/wave-top-light.png" class="wave" />
      </div>
    </div>
  </Page>
</template>

<script>
import Page from './Page.vue';
import Up from './Up.vue';

export default {
  name: 'HowToUsePage',
  components: {
    Page,
    Up
  }
};

</script>
